/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, react/no-array-index-key */
import React from 'react';
import { Button as RMDButton } from 'react-md';
import PropTypes from 'prop-types';
import { get, startCase } from 'lodash-es';

import Logo from '../Logo/Logo';

import './ModalBox.scss';

const ModalBox = ({ show, toggle, data, logo, strings }) => {
  const formatName = name =>
    name
      .split('-')
      .map(word => (/\d/.test(word) ? word.toUpperCase() : startCase(word)))
      .join(' ');

  const margin = get(logo, 'current') && !get(logo, `list.${get(logo, 'current')}.component`) ? '' : 'logo-margin';

  return show ? (
    <>
      <div className="modal">
        <div className="title">
          <div className="drawerTitle">
            <Logo logo={logo} strings={strings} />
          </div>
        </div>
        <div className="content">
          <div className={`versions ${margin}`}>
            {data.map((d, idx) => (
              <div key={`div-${idx}`} className="version">
                <b>{`${formatName(get(d, 'name', ''))}`}</b>
                {` ${get(d, 'version', '')} ${get(d, 'subVersion', '')}`}
                <br />
              </div>
            ))}
          </div>
          <div className="copyright">Copyright (C) 2012-2020 Coopengo</div>
        </div>
        <div className="actions">
          <RMDButton
            className="toggle-button"
            raised
            secondary
            title={get(strings, 'close', 'Fermer')}
            onClick={toggle}
          >
            {get(strings, 'close', 'Fermer')}
          </RMDButton>
        </div>
      </div>
      <div className="overlay" onClick={toggle} />
    </>
  ) : (
    <></>
  );
};

ModalBox.propTypes = {
  show: PropTypes.bool,
  toggle: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

ModalBox.defaultProps = {
  show: true,
  toggle: () => {},
};

export default ModalBox;
